import Phaser from "phaser";
import { data, finance } from "../data";
import { createButton } from "../modules/createButton";
import { adjustSound } from "../modules/adjustSound";
export default class Instructions extends Phaser.Scene {
  width;
  height;
  threshold;
  /** @type {Phaser.Physics.Arcade.Sprite} */
  character;
  constructor() {
    super("instructions");
  }
  init() {
    this.width = this.sys.canvas.width;
    this.height = this.sys.canvas.height;
    this.threshold = this.height - 20 * data().scaleX;
   }
  create() {
    this.createBg();
    this.createCharacter();
    this.createFrame();
    if (finance.startSound) {
      adjustSound(this, this.width / 3.7, this.height / 1.7);
    } else {
      adjustSound(
        this,
        this.width / 3.7,
        this.height / 1.7,
        Math.sqrt(this.sound.volume) //to return the volume value to its original value.
      );
    }
    if (finance.startSound) {
      this.sound.play("bgSound", { loop: true });
    }
    finance.startSound = false;
    this.addButton();
  }
  createBg() {
    this.add
      .image(0, 0, "startBg")
      .setOrigin(0)
      .setDisplaySize(this.width, this.height);
  }
  createCharacter() {
    this.character = this.physics.add
      .sprite(-10, this.threshold, "idle")
      .setOrigin(0, 1)
      .setDisplaySize(200 * data().scaleX, 200 * data().scaleX);
  }
  createFrame() {
    this.add
      .image(this.width / 2, this.height / 2, "bambooFrame")
      .setScale(0.9 * data().scaleX, 0.7 * data().scaleX);
    this.add
      .text(this.width / 2, this.height / 3.5, "Instructions", {
        color: "#323232",
        fontFamily: "Grooving",
        fontStyle: "italic",
        fontSize: "50px",
      })
      .setScale(1 * data().scaleX)
      .setOrigin(0.5);
    this.add
      .text(
        this.width / 2,
        this.height / 2.3,
        `
      "Space" or Tap (Right Side) - Jump
      "Down" or Tap (Left Side) - Slide
                    Avoid Obstacles!
      `,
        {
          color: "#323232",
          fontFamily: "Grooving",
          fontStyle: "italic",
          fontSize: "30px",
        }
      )
      .setScale(1 * data().scaleX)
      .setOrigin(0.6, 0.5);
  }
  addButton() {
    createButton(
      this,
      this.width / 2,
      this.height / 1.5,
      "play",
      0.3 * data().scaleX,
      () => {
        this.scene.start("easy");
      }
    );
  }
  update(t, dt) {}
}
